// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingLogo_container__2GSB1","loadingImage":"LoadingLogo_loadingImage__3-xRf"};